"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const antd_1 = require("antd");
const react_router_dom_1 = require("react-router-dom");
const luxon_1 = require("luxon");
const ZenithHeader_1 = __importDefault(require("../ZenithHeader"));
const ContentRouter_1 = __importDefault(require("../ContentRouter"));
const ApplicationContext_1 = require("../../context/ApplicationContext");
const { Header, Content, Footer } = antd_1.Layout;
const App = () => {
    const { setCurrentTab } = (0, ApplicationContext_1.useApplicationContext)();
    const location = (0, react_router_dom_1.useLocation)();
    const { pathname } = location;
    // when browser is refreshed this will ensure the right tab is selected
    (0, react_1.useEffect)(() => {
        setCurrentTab(pathname.split('/')[1]);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(antd_1.Layout, { children: [(0, jsx_runtime_1.jsx)(Header, Object.assign({ className: 'header' }, { children: (0, jsx_runtime_1.jsx)(ZenithHeader_1.default, {}) })), (0, jsx_runtime_1.jsx)(Content, Object.assign({ className: 'content' }, { children: (0, jsx_runtime_1.jsx)(ContentRouter_1.default, {}) })), (0, jsx_runtime_1.jsxs)(Footer, Object.assign({ className: 'footer' }, { children: ["\u00A9 Lextegrity ", luxon_1.DateTime.now().year] }))] }));
};
exports.default = App;
